const faqItems = [
  {
    q: '51漫画在线观看需要注册账号吗？',
    a: '不需要注册即可免费浏览大部分漫画内容。我们致力于提供最便捷的在线阅读体验，无需登录就能畅享海量漫画资源。注册账号后可获得收藏、历史记录等更多个性化功能。',
  },
  {
    q: '51漫画支持哪些设备阅读？',
    a: '51漫画在线支持所有主流设备，包括电脑、平板和手机。您只需通过浏览器访问即可开始阅读，无需下载任何软件或APP。移动端网页版已全面优化，下拉式阅读流畅自然。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '热门连载漫画每日实时更新，我们与多家漫画平台保持同步，确保您能第一时间阅读到最新章节。部分作品支持实时阅读模式，更新后即刻可见。',
  },
  {
    q: '51漫画在线上的漫画是否正版？',
    a: '51漫画在线观看平台严格遵守版权法规，所有漫画内容均获得正版授权或来自合法渠道。我们尊重每一位创作者的劳动成果，也请读者支持正版漫画。',
  },
  {
    q: '遇到阅读问题如何反馈？',
    a: '如遇到加载异常、页面错位或其他阅读问题，您可以通过页面底部的联系方式发送邮件给我们。技术团队会及时处理并优化，确保您的在线阅读体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">关于51漫画在线的常见疑问与解答</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 font-heading text-lg mt-0.5 whitespace-nowrap">Q{i + 1}</span>
                <span>{item.q}</span>
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-8">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}